var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "btn btn-outline-secondary",
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.exportTabWidgets($event)
        }
      }
    },
    [_vm._v(_vm._s(_vm.resource("Shared_Export")))]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }